// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__105cp","left":"InfoRow_left__2yf1r"};